export default __webpack_public_path__ + "static/media/grid1.4834661d.png";